import { render } from "./Stopped.vue?vue&type=template&id=9c49b7d4&scoped=true"
import script from "./Stopped.vue?vue&type=script&lang=js"
export * from "./Stopped.vue?vue&type=script&lang=js"

import "./Stopped.vue?vue&type=style&index=0&id=9c49b7d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c49b7d4"]])

export default __exports__